import { styled } from "@mui/material";

export const Container = styled("div")<{ scale: number }>`
	width: 343px;
	background-color: #fff;
	border-radius: 1rem;
	position: relative;
	overflow: hidden;
	transform: scale(${(props) => props?.scale});
`;

export const Header = styled("div")<{ "data-image": string }>`
	height: 188px;
	width: 100%;
	background-repeat: no-repeat;
	background-position: cover;
	background-size: cover;
	background-position: center;
	background-image: url(${(props) => props["data-image"]});
	position: relative;

	img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 258px;
		height: auto;
	}
`;

export const Body = styled("div")`
	max-width: 372px;
	margin: 0 auto;
	padding: 2rem 1rem;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	gap: 1rem;
`;

export const Title = styled("span")`
	font-family: "Baloo";
	font-size: 20px;
	text-align: center;
	color: #113b62;
	line-height: 22px;
`;

export const Text = styled("p")`
	font-family: "Inter";
	font-size: 16px;
	text-align: center;
	color: #333;
	margin: 0;
	line-height: 21px;
`;
